import { useCallback, useState } from "react";
import QueryService from '../../../services/QueryService';
import { useApp } from "../../../helpers/user";
import DataStoreService from '../../../services/DataStore';

const useLocations = () => {
  const [loading, setLoading] = useState(false);
  const [formLoaded, setFormLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [form, setForm] = useState({});
  const [data, setData] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectOptions, setSelectOptions] = useState({});
  const [defaultActiveFilters, setDefaultActiveFilters] = useState(null);

  const fetchForm = useCallback(async () => {
    if (formLoaded) {
      return;
    }

    setLoading(true);

    try {
      const { data: _dataFormStakeholder } = await DataStoreService.getForm('location');
      setForm(_dataFormStakeholder.store);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
    setFormLoaded(true);
  }, [formLoaded]);

  return {
    loading,
    fetchForm,
    setLoading,
    form,
    hasError,
    data,
    setData,
    fetch,
    setHasError,
    showFilters,
    setShowFilters,
    selectOptions,
    setSelectOptions,
    defaultActiveFilters,
    setDefaultActiveFilters,
  }
}

const useEntities = () => {
  const mod = useApp();
  const [data, setData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [formLoaded, setFormLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [hasError, setHasError] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [selectOptions, setSelectOptions] = useState({});
  const [defaultActiveFilters, setDefaultActiveFilters] = useState(null);

  const fetchForm = useCallback(async () => {
    if (formLoaded) {
      return;
    }

    setLoading(true);

    try {
      const { data: _dataFormStakeholder } = await DataStoreService.getForm('stakeholder');
      setForm(_dataFormStakeholder.store);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
    setFormLoaded(true);
  }, [formLoaded]);

  const fetch = useCallback(async () => {
    if (loaded) {
      return;
    }

    setLoading(true);

    try {
      const allData = [];
      let page = 1;
      let pages = 1;
      const perPage = 100;

      for (let i = 0; i < pages; i++) {
        const _data = await QueryService.getEntities(page, perPage);
        allData.push(..._data.data.data);
        const total = _data.data.metadata[0].total;
        pages = Math.ceil(total / perPage);
        page += 1;
      }

      setData(allData);
      await fetchForm();
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
    setLoaded(true);
    setSelectOptions((prev) => ({
      ...prev,
      entityType: [],
      entityCategory: [],
      entitySubCategory: [],
      source: [],
      origin: [],
    }));
  }, [loaded, fetchForm]);

  return {
    loading,
    fetch,
    setLoading,
    fetchForm,
    form,
    hasError,
    setHasError,
    showFilters,
    setShowFilters,
    selectOptions,
    data,
    setSelectOptions,
    defaultActiveFilters,
    setDefaultActiveFilters,
  }
}

export default function useFindInformationStore() {
  const locations = useLocations();
  const entities = useEntities();
  const [defaultTab, setDefaultTab] = useState(null);

  return { locations, entities, defaultTab, setDefaultTab };
}
